import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

import Tile from '@components/Tile'
import Alert from '@components/Alert'

export const Finish = () => {
    const dataStore = useSelector(state => state.landingZoneMigration)
    const isInternetOnly = dataStore.selected?.lzType === 'LZ_INTERNET'

    return (
        <Tile sx={{p: 0}}>
            <Box sx={{p: 2, pb: 0}}>
                <Typography variant={'h2'}>Firewall Migration</Typography>
                <Alert severity={'success'} title={'Migration completed'} sx={{mt: 2, mb: 2}}>
                    <Typography variant={'body2'} sx={{mt: 1}}>The Landing-Zone is migrated to the new firewall</Typography>
                </Alert>


                <Typography variant={'h5'} sx={{mb: 2, mt: 3}}>Congratulations!</Typography>
                
                <Typography variant={'body1'} sx={{mb: 2, lineHeight: 1.8}}>
                    Your landing zone migration to the vWAN firewall is now complete! To make sure everything went correctly, you can check the state of the following resources:
                </Typography>

                {isInternetOnly ? (
                    <Box component="ul" sx={{mb: 2, pl: 3}}>
                        <li>
                            <Typography variant={'body2'} sx={{mb: 1}}>
                                <strong>Landing zone default route table(s)</strong> <code>udr-iasp-&lt;region&gt;-lz-network</code>: you should see that all the routes are now routing towards a new IP which is the vWAN firewall
                            </Typography>
                        </li>
                    </Box>
                ) : (
                    <Box component="ul" sx={{mb: 2, pl: 3}}>
                        <li>
                            <Typography variant={'body2'} sx={{mb: 1}}>
                                <strong>Landing zone default route table(s)</strong> <code>udr-iasp-&lt;region&gt;-lz-network</code>: you should see in the route table(s) configuration that "Propagate Gateway Routes" parameter is set to "No"
                            </Typography>
                        </li>
                        <li>
                            <Typography variant={'body2'} sx={{mb: 1}}>
                                <strong>Peering</strong> <code>peer-iasp-&lt;region&gt;-lz-network</code> of your virtual network(s) <code>vnet-iasp-&lt;region&gt;-lz-network</code>: you should see that the "Enable remote gateway or route server" parameter is deactivated
                            </Typography>
                        </li>
                    </Box>
                )}

                <Typography variant={'body1'} sx={{mb: 2, lineHeight: 1.8}}>
                    Don't forget to check up your monitoring to ensure everything works. If so, you can now complete the migration (caution: you won't be able to rollback after).
                </Typography>
            </Box>
        </Tile>
    )
}

export default Finish